import JSONSerializer from '@ember-data/serializer/json';
import { underscore } from '@ember/string';

// eslint-disable-next-line ember/no-classic-classes
export default JSONSerializer.extend({
  primaryKey: 'id',
  attrs: {
    lineItems: {
      embedded: 'always'
    }
  },
  keyForAttribute(attr) {
    return underscore(attr);
  },
  normalizeResponse(store, primaryModelClass, payload, id, requestType) {
    if (payload.order) {
      // eslint-disable-next-line no-param-reassign
      payload = payload.order;
    }
    return this._super(store, primaryModelClass, payload, id, requestType);
  },
  normalizeQueryResponse(store, primaryModelClass, payload, id, requestType) {
    return this._super(store, primaryModelClass, payload, id, requestType);
  },
  serializeAttribute(snapshot, json, key, attribute) {
    if (!snapshot.record.isNew && attribute.options.readOnly) {
      return;
    }
    this._super(snapshot, json, key, attribute);
  },
  serialize(snapshot, options) {
    const json = this._super(snapshot, options);

    /**
     * If taxes are auto-applied, we should not try to populate the taxes array manually
     */
    if (json.pricing_options?.auto_apply_taxes) {
      delete json.taxes;
    }

    /**
     * New Orders should not include a version. This can happen when creating multiple
     * Orders from a template.
     */
    if (snapshot.record.isNew) {
      delete json.version;
    }
    return json;
  }
});